// frontend/src/App.js
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import { Container } from '@mui/material';

const Overview = lazy(() => import('./pages/Overview'));
const Trading = lazy(() => import('./pages/Trading'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Analytics = lazy(() => import('./pages/Analytics'));
const Market = lazy(() => import('./pages/Market'));

function App() {
  return (
    <Router>
      <NavigationBar />
      <Container maxWidth="lg" sx={{ marginTop: 4 }}>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/dashboard" element={<Navigate to="/dashboard" />} />
            <Route path="/dashboard/overview" element={<Overview />} />
            <Route path="/dashboard/trading" element={<Trading />} />
            <Route path="/dashboard/portfolio" element={<Portfolio />} />
            <Route path="/dashboard/analytics" element={<Analytics />} />
            <Route path="/dashboard/market" element={<Market />} />
          </Routes>
        </Suspense>
      </Container>
    </Router>
  );
}

export default App;